// extracted by mini-css-extract-plugin
module.exports = {"actions":"ReportingDisclaimer_actions__1gZup","link":"ReportingDisclaimer_link__2qNdx","action":"ReportingDisclaimer_action__1uLZD"};